import {reactive} from 'vue';

interface ChatbotStorageData {
  activeAssistantChatId: string | null;
  hasUsedChatbot: boolean;
}

class PageStore {
  private _chatbotStorageKey = 'chatbot_data';

  activeVoucherCode: string = null;
  chatBotData: ChatbotStorageData = {
    activeAssistantChatId: null,
    hasUsedChatbot: false
  };

  constructor() {
    if (window.__globalConfig) {
      this.activeVoucherCode = window.__globalConfig.activeVoucherCode;
    }

    const chatBotDataStored = localStorage.getItem(this._chatbotStorageKey);
    if (chatBotDataStored) {
      try {
        this.chatBotData = JSON.parse(chatBotDataStored);
      } catch {
        // do nothing, keep default values
      }
    }
  }

  setActiveAssistantChatId(chatId: string | null) {
    this.chatBotData.activeAssistantChatId = chatId;
    this.saveChatbotData();
  }

  setHasUsedChatbot(value: boolean) {
    this.chatBotData.hasUsedChatbot = value;
    this.saveChatbotData();
  }

  private saveChatbotData() {
    const data: ChatbotStorageData = {
      activeAssistantChatId: this.chatBotData.activeAssistantChatId,
      hasUsedChatbot: this.chatBotData.hasUsedChatbot
    };
    localStorage.setItem(this._chatbotStorageKey, JSON.stringify(data));
  }
}

const promotionTeaserStore = new PageStore();
export default reactive(promotionTeaserStore);
export {PageStore};
